<div class="general-info">
  <div class="general-info__label">Global Network<span class="sgl-arrows" aria-hidden="true"></span></div>
  <div class="general-info__stats">
    <div class="general-info__stat">
      <span class="general-info__stat--value">55+</span>
      <span class="general-info__stat--label">Countries</span>
    </div>
    <div class="general-info__stat">
      <span class="general-info__stat--value">200+</span>
      <span class="general-info__stat--label">Locations</span>
    </div>
    <div class="general-info__stat">
      <span class="general-info__stat--value">5,100+</span>
      <span class="general-info__stat--label">Employees</span>
    </div>
    <div class="general-info__stat">
      <span class="general-info__stat--value">6</span>
      <span class="general-info__stat--label">Continents</span>
    </div>
  </div>
  <p class="general-info__description">
    Every office keeps its own local team and opening hours. Look up your nearest office, its contacts, and opening
    times on our global website.
  </p>
  <button (click)="window.open('https://www.scangl.com/about/our-locations/', 'blank')" mat-flat-button>
    Find an Office
    <span class="sgl-arrows" aria-hidden="true"></span>
  </button>
</div>
